import { AccordionDetails, withStyles } from '@material-ui/core';

export default withStyles(theme => ({
  root: {
    padding: theme.spacing(0),
    display: 'block',
  },
}))(AccordionDetails);
